import Icon, { SvgIconName } from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import {
  FeedbackButton,
  FlexDiv,
  StyledFullWidthSection,
  TextContainer,
  Wrapper,
} from "components/components/Iris/LandingPageInfo/EarlyAdopterBanner/style";
import { useCustomerFeedbackModalContext } from "contexts/CustomerFeedbackModalContext";
import React from "react";

const EarlyAdopterBanner: React.FC = () => {
  const { open: openCustomerFeedbackModal } = useCustomerFeedbackModalContext();
  return (
    <StyledFullWidthSection>
      <Wrapper className="container px-6">
        <h2>Become an early adopter</h2>
        <FlexDiv>
          <TextContainer>
            <p>
              We&apos;re continuously making more data available through IRIS
              and further reducing latency. This production-grade data shares
              the same source and output format as the Insights Solution APIs.
            </p>
            <p>
              <b>
                Become an early adopter and help us improve the service by
                sharing your{" "}
                <FeedbackButton
                  buttonText="feedback"
                  className="plain-inline"
                  onClick={openCustomerFeedbackModal}
                />
                .
              </b>
            </p>
          </TextContainer>
          <Icon iconName={SvgIconName.EarlyAdopter} size={IconSize.xLarge} />
        </FlexDiv>
      </Wrapper>
    </StyledFullWidthSection>
  );
};

export default EarlyAdopterBanner;
